import { render, staticRenderFns } from "./MatchListActions.vue?vue&type=template&id=96ac440a&"
import script from "./MatchListActions.vue?vue&type=script&lang=js&"
export * from "./MatchListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports